/**
 * Raven 已下线，保留空实现以兼容既有调用。
 */
type RavenDoneHandler = (
  traceId: string | number,
  data: unknown
) => void

function noop(..._args: unknown[]): void {
  void _args
}

const raven = {
  trackEvent: noop,
  setAttrs: noop,
  setConfig: noop,
  use: noop,
  trackRequest: (..._args: unknown[]): RavenDoneHandler => noop,
}

export default raven
